import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GroupOperationJob,
  GroupOperationsState,
  GroupOperationsStats,
} from 'redux/types/GroupOperations.types';

const initialState: GroupOperationsState = {
  stats: {
    inProgressJobs: 0,
  },
  jobs: [],
  isConnected: false,
  error: null,
};

const groupOperationsSlice = createSlice({
  name: 'groupOperations',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
      if (!action.payload) {
        state.error = 'SSE connection lost';
      } else {
        state.error = null;
      }
    },

    handleFullUpdate: (
      state,
      action: PayloadAction<{
        stats: GroupOperationsStats;
        jobs: GroupOperationJob[];
      }>
    ) => {
      state.stats = action.payload.stats;
      state.jobs = action.payload.jobs;
      state.error = null;
    },

    handlePartialUpdate: (state, action: PayloadAction<GroupOperationJob>) => {
      const updatedJob = action.payload;

      const jobIndex = updatedJob.jobId
        ? state.jobs.findIndex((job) => job.jobId === updatedJob.jobId)
        : state.jobs.findIndex(
            (job) =>
              job.allocationFileId === updatedJob.allocationFileId &&
              job.taskType === updatedJob.taskType
          );

      if (jobIndex !== -1) {
        state.jobs[jobIndex] = updatedJob;
      } else {
        state.jobs.push(updatedJob);
      }

      // Recalculate stats based on current jobs
      state.stats.inProgressJobs = state.jobs.filter(
        (job) => job.status === 'IN_PROGRESS'
      ).length;
    },

    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    resetGroupOperations: (state) => {
      state.stats = initialState.stats;
      state.jobs = initialState.jobs;
      state.isConnected = false;
      state.error = null;
    },

    // Remove completed/failed jobs after some time if needed
    clearCompletedJobs: (state) => {
      state.jobs = state.jobs.filter((job) => job.status === 'IN_PROGRESS');
      state.stats.inProgressJobs = state.jobs.length;
    },
  },
});

export const {
  setConnectionStatus,
  handleFullUpdate,
  handlePartialUpdate,
  setError,
  resetGroupOperations,
  clearCompletedJobs,
} = groupOperationsSlice.actions;

export default groupOperationsSlice.reducer;
